import { ConsortiumType } from 'app/modules/orgManagement/models';

export enum ActivityCategory {
  ACCOUNT_APPLICATION_FRAUD = 'Account Application Fraud',
  ACCOUNT_TAKEOVER_VICTIM = 'Account Takeover (Victim)',
  ACH_FRAUD = 'ACH Fraud',
  BONUS_REFERRAL_ABUSE = 'Bonus / Referral Abuse',
  BUST_OUT_FRAUD = 'Bust-Out Fraud',
  CARD_FRAUD = 'Card Fraud',
  CHECK_FRAUD = 'Check Fraud',
  FIRST_PARTY_ABUSE = 'First-Party Abuse',
  FRAUD_VICTIM_NON_ATO = 'Fraud Victim (Non-ATO)',
  HIGH_RISK_INDIVIDUAL = 'High-Risk Individual',
  HIGH_RISK_JURISDICTION_ACTIVITY = 'High-Risk Jurisdiction Activity',
  IDENTITY_THEFT_VICTIM = 'Identity Theft (Victim)',
  LAYERING_ML_ACTIVITY = 'Layering / Money Laundering Activity',
  MALWARE_RAT_ACTIVITY = 'Malware / Remote Access Tool (RAT) Activity',
  MERCHANT_OR_THIRD_PARTY_FRAUD = 'Merchant or Third-Party Fraud',
  MONEY_MULE_ACTIVITY = 'Money Mule Activity',
  P2P_RTP_FRAUD = 'P2P / RTP Fraud',
  PHISHING_VISHING_SMISHING = 'Phishing / Vishing / Smishing',
  SANCTIONS_WATCHLIST_MATCH = 'Sanctions / Watchlist Match',
  STRUCTURING_SMURFING = 'Structuring / Smurfing',
  SYNTHETIC_IDENTITY_FRAUD = 'Synthetic Identity Fraud',
  SOCIAL_ENGINEERING_SCAM = 'Social Engineering Scam',
  WIRE_FRAUD = 'Wire Fraud',
  UNDETERMINABLE = 'Undeterminable',
}

export enum InvestigationOutcome {
  BLOCKED = 'Blocked',
  ESCALATED = 'Escalated',
  CONFIRMED_UNUSUAL = 'Confirmed Unusual',
  FALSE_POSITIVE = 'False Positive',
  UNDER_INVESTIGATION = 'Under Investigation',
  UNDETERMINED = 'Undetermined',
}

export const INVESTIGATION_OUTCOME_DISPLAY: Record<
  InvestigationOutcome,
  {
    label: string;
    color: 'error' | 'warning' | 'info' | 'success' | 'default';
    variant: 'filled' | 'ghost';
  }
> = {
  [InvestigationOutcome.BLOCKED]: {
    label: 'Restricted',
    color: 'error',
    variant: 'filled',
  },
  [InvestigationOutcome.CONFIRMED_UNUSUAL]: {
    label: 'High severity',
    color: 'error',
    variant: 'ghost',
  },
  [InvestigationOutcome.ESCALATED]: {
    label: 'Monitoring',
    color: 'warning',
    variant: 'ghost',
  },
  [InvestigationOutcome.UNDER_INVESTIGATION]: {
    label: 'Under investigation',
    color: 'info',
    variant: 'ghost',
  },
  [InvestigationOutcome.UNDETERMINED]: {
    label: 'Undetermined',
    color: 'default',
    variant: 'ghost',
  },
  [InvestigationOutcome.FALSE_POSITIVE]: {
    label: 'False positive',
    color: 'success',
    variant: 'ghost',
  },
};

export interface ConsortiumAlertV2 {
  investigation_outcome: InvestigationOutcome | null;
  activity_categories: ActivityCategory[];
  created_at: string;
  dispositioned_at: string | null;
  last_touched_at: string;
  org_type: ConsortiumType;
}

export interface ConsortiumAlertV2EntityResponse {
  alerts: ConsortiumAlertV2[];
  has_more: boolean;
}

export type ConsortiumAlertsV2Response = Record<
  string,
  ConsortiumAlertV2EntityResponse
>;
